/**
 * Created by Arne on 08.01.2015.
 */

angular.module('cfn').factory('cfnGridEvents', [
  'cfnGridSorting',
  function(cfnGridSorting) {
    var service = {};

    service.initEvents = function(scope, element, attrs) {
      var serviceInstance = {};
      scope.headerClicked = function(column) {
        if (column.sortable) {
          scope.$cfnGridSorting.toggleSortCol(column);
        }
        if (scope.headerclick()) {
          scope.headerclick()(column);
        }
      };

      scope.docheckclick = function(item) {
        scope.itemSelectionChanged(item);
      };

      scope.doclick = function(col, item, event) {
        // todo: single / multi selection

        if (!scope.disableclickselection && !item.$cfngrid_inactive) {
          if (scope.multiselection === 'false' || !scope.multiselection) {
            scope.clearSelection();
            item.$cfngrid_selected = true;
            scope.itemSelectionChanged(item);
          } else {
            item.$cfngrid_selected = !item.$cfngrid_selected;
            scope.itemSelectionChanged(item);
          }
        }
        if (scope.cellclick()) {
          scope.cellclick()(col, item, event);
        }
        if (scope.rowclick()) {
          var rowIndex = item.id;
          var rowData = item;
          scope.rowclick()(rowData, rowIndex);
        }
      };

      scope.dodblclick = function(col, item) {
        // doubleclick leads to selection!

        if (!scope.disableclickselection && !item.$cfngrid_inactive) {
          item.$cfngrid_selected = true;
          scope.selected[item.id] = item;
        }
        if (scope.celldblclick()) {
          scope.celldblclick()(col, item);
        }
        if (scope.rowdblclick()) {
          var rowIndex = item.id;
          var rowData = item;
          scope.rowdblclick()(rowData, rowIndex);
        }
      };

      scope.domouseenter = function(col, item, evt) {
        scope.hoverstart()(col, item, evt);
      };

      scope.domouseleave = function(col, item, evt) {
        scope.hoverend()(col, item, evt);
      };

      scope.onDeleteClick = function(item) {
        scope.onDelete()(item);
      };
      return serviceInstance;
    };

    return service;
  }
]);
